/**
 * Pure calendar date helpers (no RN deps, so unit-testable in the node jest
 * env). Kept out of hooks/useLivesCalendar.ts which pulls in react-native.
 */

/** Local YYYY-MM-DD key for a date. */
export const dateToISO = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

/**
 * CORE-225 — every local ISO day-key an item spans (start-day … end-day
 * inclusive), from `startDateTimeUtc` + `durationMinutes`. Single-day items
 * return one key; a multi-day offline event returns several so it shows on the
 * whole calendar range, not just the start day. Capped at 366 days.
 */
export const getItemSpanDaysISO = (
  item: { startDateTimeUtc: string; durationMinutes?: number | null },
): string[] => {
  const start = new Date(item.startDateTimeUtc).getTime();
  if (!Number.isFinite(start)) return [];
  const endTime = start + Math.max(0, (item.durationMinutes ?? 0) * 60_000);
  const cur = new Date(start);
  cur.setHours(0, 0, 0, 0);
  const endDay = new Date(endTime);
  endDay.setHours(0, 0, 0, 0);
  const days: string[] = [];
  for (let i = 0; i <= 366 && cur.getTime() <= endDay.getTime(); i++) {
    days.push(dateToISO(cur));
    cur.setDate(cur.getDate() + 1);
  }
  return days.length ? days : [dateToISO(new Date(start))];
};
